import store from '@/store'

export default {
  inserted (el, binding, vnode) {
    const { value } = binding
    const permissions = store.getters.getPermissions
    if (value && value instanceof Array && value.length > 0) {
      if (permissions && permissions.length > 0) {
        const permissionRoles = value
        const hasPermission = permissions.some(p => {
          return permissionRoles.includes(p)
        })
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      } else {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
